import type { ConsoleRoute } from '../index';
import { FulfillmentPage } from './FulfillmentPage';

/** §16.2 Fulfillment: owner, SKU, address region, carrier or pickup, dispatch SLA, exception age, delivery evidence. */
export const fulfillmentRoutes: ConsoleRoute[] = [
  {
    path: 'fulfillment',
    handle: { permission: ['fulfillment.update', 'claims.view'], title: 'Fulfillment' },
    element: <FulfillmentPage />,
  },
];
